import { render } from "./ChatSearchUserPage.vue?vue&type=template&id=033e05aa"
import script from "./ChatSearchUserPage.vue?vue&type=script&lang=js"
export * from "./ChatSearchUserPage.vue?vue&type=script&lang=js"
script.render = render

export default script